import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'
import { ButtonType } from '@/components/atoms/button'
import { CompletionButton } from '@/components/molecules/self-checkin/completion-button'

type Props = {
  onClickTop: () => void
}
export const FrontSupport: React.FC<Props> = ({ onClickTop }) => {
  const { t } = useTranslation()

  return (
    <>
      <div css={innerStyle}>
        <h1 css={descriptionStyle}>{t('Please complete the procedure at the front desk')}</h1>
        <img
          src={require('@/static/images/self-checkin/complete-image.svg')}
          alt={t('Self-checkin complete')}
          css={checkinCompleteImgStyle}
        />
        <span css={noticeStyle}>{t('Please pick up your key and settle your account at the front desk')}</span>
        <div css={frontSupportButtonWrapperStyle}>
          <CompletionButton buttonType={ButtonType.Secondary} onClick={onClickTop}>
            {t('Top')}
          </CompletionButton>
        </div>
      </div>
    </>
  )
}

const innerStyle = css(
  {
    boxSizing: 'border-box',
    width: '100%',
    height: 820,
    paddingTop: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#FFF',
  },
  createSelfCheckinResponsiveStyle({
    portrait: { height: 1180, paddingTop: 313 },
    landscape13: { height: 1024 },
  }),
)

const descriptionStyle = css(
  {
    width: '100%',
    margin: 0,
    color: '#D68E0F',
    fontSize: 26,
    fontWeight: 'bold',
    textAlign: 'center',
    letterSpacing: 1.3,
    lineHeight: '36px',
  },
  createSelfCheckinResponsiveStyle({ landscape13: { fontSize: 30, lineHeight: '42px', letterSpacing: 1.5 } }),
)

const checkinCompleteImgStyle = css({
  width: 401,
  height: 279,
  marginTop: 59,
  display: 'block',
})

const noticeStyle = css(
  {
    width: '100%',
    marginTop: 60,
    fontSize: 20,
    color: '#272727',
    lineHeight: '28px',
    letterSpacing: 1,
    display: 'block',
    textAlign: 'center',
  },
  createSelfCheckinResponsiveStyle({ landscape13: { fontSize: 24, lineHeight: '34px', letterSpacing: 1.2 } }),
)

const frontSupportButtonWrapperStyle = css({ marginTop: 31 })
